import Vue from "vue";
import VueRouter from "vue-router";
import DashboardView from "../views/DashboardView.vue";
import DashboardLayout from "../layouts/defaultLayout.vue";

const routes = [
  // #region discount code
  {
    path: '/discount-code',
    name: 'DiscountCode',
    meta: {
      layout: DashboardLayout,
    },
    component: () => import(/* webpackChunkName: "DiscountCode" */ '../views/DiscountCode/listView.vue')
  },
  {
    path: '/discount-code/:id',
    name: 'DiscountCodeDetails',
    meta: {
      layout: DashboardLayout,
    },
    component: () => import(/* webpackChunkName: "DiscountCodeDetails" */ '../views/DiscountCode/detailsView.vue')
  },

  /* ====== free Provinces ====== */
  {
    name: 'freeProvinces',
    path: '/free-provinces',
    meta: { layout: DashboardLayout },
    component: () => import('../views/FreeProvinces/ListView.vue'),
  },

  /* ====== Tools Section ====== */
  //games
  {
    name: 'toolsGames',
    path: '/tools/games/list',
    meta: { layout: DashboardLayout },
    component: () => import('../views/Tools/games/Listview.vue'),
  },

  //add based content type
  {
    name: "toolsGamesAddText",
    path: "/tools/games/text/add",
    meta: { layout: DashboardLayout },
    component: () => import("../views/Tools/games/addBasedType/AddViewText.vue"),
  },
  {
    name: "toolsGamesAddImage",
    path: "/tools/games/image/add",
    meta: { layout: DashboardLayout },
    component: () => import("../views/Tools/games/addBasedType/AddViewImage.vue"),
  },
  {
    name: "toolsGamesAddVideo",
    path: "/tools/games/video/add",
    meta: { layout: DashboardLayout },
    component: () => import("../views/Tools/games/addBasedType/AddViewVideo.vue"),
  },

  {
    name: "toolsGameVideo",
    path: "/tools/games/video/edit/:id",
    meta: { layout: DashboardLayout },
    component: () => import("../views/Tools/games/editBasedType/EditViewVideo"),
  },
  {
    name: "toolsGameText",
    path: "/tools/games/text/edit/:id",
    meta: { layout: DashboardLayout },
    component: () => import("../views/Tools/games/editBasedType/EditViewText"),
  },
  {
    name: "toolsGameImage",
    path: "/tools/games/image/edit/:id",
    meta: { layout: DashboardLayout },
    component: () => import("../views/Tools/games/editBasedType/EditViewImage"),
  },

  //sleep
  {
    name: 'toolsSleep',
    path: '/tools/sleep/list',
    meta: { layout: DashboardLayout },
    component: () => import('../views/Tools/sleep/ListView.vue'),
  },
  {
    name: "toolsSleepAdd",
    path: "/tools/sleep/add",
    meta: { layout: DashboardLayout },
    component: () => import("../views/Tools/sleep/AddView.vue"),
  },
  {
    name: "toolsSleepEdit",
    path: "/tools/sleep/edit/:id",
    meta: { layout: DashboardLayout },
    component: () => import("../views/Tools/sleep/EditView.vue"),
  },
  //poscast
  {
    name: 'toolsPodcast',
    path: '/tools/podcast/list',
    meta: { layout: DashboardLayout },
    component: () => import('../views/Tools/Podcast/ListView.vue'),
  },
  {
    name: "toolsPodcastAdd",
    path: "/tools/podcast/add",
    meta: { layout: DashboardLayout },
    component: () => import("../views/Tools/Podcast/AddView.vue"),
  },
  {
    name: "toolsPodcastEdit",
    path: "/tools/podcast/edit/:id",
    meta: { layout: DashboardLayout },
    component: () => import("../views/Tools/Podcast/EditView.vue"),
  },
  // Dos And Don'ts
  {
    name: 'toolsDosDonts',
    path: '/tools/dos-donts',
    meta: { layout: DashboardLayout },
    component: () => import('../views/Tools/DosDonts/DosDontsView.vue'),
  },

  // Articles
  {
    name: 'toolsArticles',
    path: '/tools/articles/list',
    meta: { layout: DashboardLayout },
    component: () => import('../views/Tools/articles/Listview.vue'),
  },
  {
    name: "toolsArticleAdd",
    path: "/tools/articles/add",
    meta: { layout: DashboardLayout },
    component: () => import("../views/Tools/articles/AddView.vue"),
  },
  {
    name: "toolsArticleEdit",
    path: "/tools/articles/edit/:id",
    meta: { layout: DashboardLayout },
    component: () => import("../views/Tools/articles/EditView.vue"),
  },
  //educationalVideos
  {
    name: 'toolsEducationalVideos',
    path: '/tools/educationalVideos/list',
    meta: { layout: DashboardLayout },
    component: () => import('../views/Tools/educationalVideos/Listview.vue'),
  },
  {
    name: "toolsEducationalVideosAdd",
    path: "/tools/educationalVideos/add",
    meta: { layout: DashboardLayout },
    component: () => import("../views/Tools/educationalVideos/AddView.vue"),
  },
  {
    name: "toolsEducationalVideosEdit",
    path: "/tools/educationalVideos/edit/:id",
    meta: { layout: DashboardLayout },
    component: () => import("../views/Tools/educationalVideos/EditView.vue"),
  },

  /* ====== Nutrition Section ====== */
  // Food
  {
    name: 'foodsList',
    path: '/foods-list',
    meta: { layout: DashboardLayout },
    component: () => import('../views/Nutrition/Food/meals/FoodsListView.vue'),
  },
  {
    name: 'usersFoodsList',
    path: '/users-foods-list',
    meta: { layout: DashboardLayout },
    component: () => import('@/views/Nutrition/Food/userMeals/UsersListView.vue'),
  },
  {
    name: 'addNewFood',
    path: '/foods-list/add',
    meta: { layout: DashboardLayout },
    component: () => import('../views/Nutrition/Food/meals/AddFoodView.vue'),
  },
  {
    name: 'addNewMaterial',
    path: '/foods-list/add-material',
    meta: { layout: DashboardLayout },
    component: () => import('../views/Nutrition/Food/meals/AddMaterialView.vue'),
  },
  {
    name: 'editFood',
    path: '/foods-list/edit/:id',
    meta: { layout: DashboardLayout },
    component: () => import('../views/Nutrition/Food/meals/EditFoodView.vue'),
  },
  {
    name: 'editUserFood',
    path: '/user-foods-list/edit/:id',
    meta: { layout: DashboardLayout },
    component: () => import('../views/Nutrition/Food/userMeals/EditUserFood.vue'),
  },
  {
    name: 'editUserMeal',
    path: '/user-meals-list/edit/:id',
    meta: { layout: DashboardLayout },
    component: () => import('../views/Nutrition/Food/userMeals/EditUserMeal.vue'),
  },
  {
    name: 'foodsFeedback',
    path: '/foods-feedback',
    meta: { layout: DashboardLayout },
    component: () => import('../views/Nutrition/Food/feedback/index.vue'),
  },
  {
    name: 'foodPattern',
    path: '/foods-pattern',
    meta: { layout: DashboardLayout },
    component: () => import('../views/Nutrition/Food/mealPattern/listView.vue'),
  },
  {
    name: 'foodPatternCreate',
    path: '/foods-pattern/create',
    meta: { layout: DashboardLayout },
    component: () => import('../views/Nutrition/Food/mealPattern/createView.vue'),
  },
  {
    name: 'foodPatternEdit',
    path: '/foods-pattern/edit/:id',
    meta: { layout: DashboardLayout },
    component: () => import('../views/Nutrition/Food/mealPattern/editView.vue'),
  },
  {
    name: 'foodPatternMeal',
    path: '/foods-pattern/meal/:id',
    meta: { layout: DashboardLayout },
    component: () => import('../views/Nutrition/Food/mealPattern/addMeal.vue'),
  },
  {
    name: 'foodIngredients',
    path: '/foods-ingredients',
    meta: { layout: DashboardLayout },
    component: () => import('../views/Nutrition/Food/ingredients/listView.vue'),
  },
  {
    name: 'foodIngredients',
    path: '/foods-ingredients/create',
    meta: { layout: DashboardLayout },
    component: () => import('../views/Nutrition/Food/ingredients/createView.vue'),
  },
  {
    name: 'foodIngredientsEdit',
    path: '/foods-ingredients/edit/:id',
    meta: { layout: DashboardLayout },
    component: () => import('../views/Nutrition/Food/ingredients/editView.vue'),
  },

  // Diet
  {
    name: "dietsList",
    path: "/diets-list",
    meta: { layout: DashboardLayout },
    component: () => import("../views/Nutrition/Diet/ListView.vue"),
  },

  //  #region Users 
  // users have children
  {
    path: "/users-with-children",
    name: "usersHaveChildren",
    component: () => import("../views/Users/HaveChildren/ListView.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },
  {
    path: "/users-with-children/add-user",
    name: "Adduser",
    component: () => import("../views/Users/HaveChildren/AddUser.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },
  {
    path: "/users-with-children/edit/:id",
    name: "EditUser",
    component: () => import("../views/Users/HaveChildren/EditUser.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },
  {
    path: "/users-with-children/edit-package/:id",
    name: "EditUser",
    component: () => import("../views/Users/HaveChildren/editPackage.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },

  {
    path: "/users-with-children/child-development-status/:id",
    name: "ChildDevelopmentStatus",
    component: () =>
      import("../views/Users/HaveChildren/ChildDevelopmentStatus.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },
  {
    path: "/users-with-children/results-of-grouping-questionnair/:id",
    name: "resultsOfGroupingQuestionnair",
    component: () =>
      import("../views/Users/HaveChildren/resultsOfGroupingQuestionnair.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },

  // users have not children
  {
    path: "/users-not-children",
    name: "usersHaveNotChildren",
    component: () => import("../views/Users/HaveNotChildren/ListView.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },
  {
    path: "/users-not-children/add",
    name: "usersHaveNotChildrenAdd",
    component: () => import("../views/Users/HaveNotChildren/AddUser.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },
  {
    path: "/users-not-children/edit/:id",
    name: "usersHaveNotChildrenEdit",
    component: () => import("../views/Users/HaveNotChildren/EditUser.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },
  // users pregnant
  {
    path: "/users-is-pregnant",
    name: "usersIsPregnant",
    component: () => import("../views/Users/Pregnant/ListView.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },
  {
    path: "/users-is-pregnant/add",
    name: "usersHaveNotChildrenAdd",
    component: () => import("../views/Users/Pregnant/AddUser.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },
  {
    path: "/users-is-pregnant/edit/:id",
    name: "usersHaveNotChildrenEdit",
    component: () => import("../views/Users/Pregnant/EditUser.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },

  /* ====== Questionnaire Section ====== */
  // initial questionnaire
  {
    path: "/initial-answers",
    name: "initialAnswers",
    component: () => import("../views/Questionnaire/Initial/AnswerList.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },
  {
    path: "/initial-answers/details/:id",
    name: "initialAnswersDetails",
    component: () => import("../views/Questionnaire/Initial/AnswerDetails.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },
  {
    path: "/initial-questionnaire/list",
    name: "initialQuestionnaireList",
    component: () => import("../views/Questionnaire/Initial/ListsView.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },
  {
    path: "/initial-questionnaire/add",
    name: "initialQuestionnaireAdd",
    component: () => import("../views/Questionnaire/Initial/AddView.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },
  {
    path: "/initial-questionnaire/edit/:id",
    name: "initialQuestionnaireEdit",
    component: () => import("../views/Questionnaire/Initial/EditView.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },
  {
    path: "/users-questions",
    name: "usersQuestions",
    component: () => import("../views/Questionnaire/User/listView.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },
  {
    path: "/users-questions/edit/:id",
    name: "usersQuestions",
    component: () => import("../views/Questionnaire/User/editView.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },
  {
    path: "/questions-list",
    name: "questionsList",
    component: () => import("../views/Questionnaire/List/listView.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },
  {
    path: "/questions-list/create",
    name: "questionsListCreate",
    component: () => import("../views/Questionnaire/List/createView.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },
  {
    path: "/questions-list/edit/:id",
    name: "questionsListEdit",
    component: () => import("../views/Questionnaire/List/editView.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },
  {
    path: "/questions-category",
    name: "questionsCategory",
    component: () => import("../views/Questionnaire/Category/listView.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },
  // mental questionnaire
  {
    path: "/mental-answers",
    name: "mentalAnswers",
    component: () => import("../views/Questionnaire/Mental/AnswerList.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },
  {
    path: "/mental-answers/details/:id",
    name: "mentalAnswersDetails",
    component: () => import("../views/Questionnaire/Mental/AnswerDetails.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },
  {
    path: "/mental-questionnaire/list",
    name: "mentalQuestionnaireList",
    component: () => import("../views/Questionnaire/Mental/ListView.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },
  {
    path: "/mental-questionnaire/add",
    name: "mentalQuestionnaireAdd",
    component: () => import("../views/Questionnaire/Mental/AddView.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },
  {
    path: "/mental-questionnaire/edit/:id",
    name: "mentalQuestionnaireEdit",
    component: () => import("../views/Questionnaire/Mental/EditView.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },
  {
    path: "/payment",
    name: "payment",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Payment/listView"),
    meta: {
      layout: DashboardLayout,
    },
  },

  /* ====== Dashboard Section ====== */
  {
    path: "/",
    name: "dashboard",
    component: DashboardView,
    meta: {
      layout: DashboardLayout,
    },
  },

  /* ====== AboutUs Section ====== */
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About/AboutView.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },
  //  ticket section
  {
    path: "/ticket",
    name: "ticket",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Ticket/listView"),
    meta: {
      layout: DashboardLayout,
    },
  },

  {
    path: "/ticket/answer/:id",
    name: "ticketAnswer",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Ticket/chatRoom"),
  },

  // food comments
  {
    path: "/survey",
    name: "survey",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/FoodComments/listView"),
    meta: {
      layout: DashboardLayout,
    },
  },

  // forum section
  {
    path: "/forum",
    name: "forum",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Forum/forumList"),
    meta: {
      layout: DashboardLayout,
    },
  },

  {
    path: "/forum-user-request",
    name: "forumUserRequest",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Forum/userRequests"),
    meta: {
      layout: DashboardLayout,
    },
  },
  {
    path: "/forum/messages-room/:id",
    name: "forumMessagesList",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Forum/messagesList"),
    meta: {
      layout: DashboardLayout,
    },
  },
  {
    path: "/forum/create",
    name: "forumMembersListCreated",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Forum/createForum"),
    meta: {
      layout: DashboardLayout,
    },
  },
  {
    path: "/forum/members/:id",
    name: "forumMembersList",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Forum/membersList"),
    meta: {
      layout: DashboardLayout,
    },
  },
  //rules section
  {
    path: "/rules",
    name: "rules",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Rules/index.vue"),
    meta: {
      layout: DashboardLayout,
    },
  },


  // message section
  {
    path: "/messages",
    name: "messages",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Messages/listView"),
    meta: {
      layout: DashboardLayout,
    },
  },
  {
    path: "/messages/send-messages",
    name: "sendMessages",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Messages/sendMessages"),
    meta: {
      layout: DashboardLayout,
    },
  },

  // faq section
  {
    path: "/faq",
    name: "faq",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Faq/listView"),
    meta: {
      layout: DashboardLayout,
    },
  },

  {
    path: "/faq/create",
    name: "createFaq",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Faq/createFaq"),
    meta: {
      layout: DashboardLayout,
    },
  },

  // counseling section
  {
    path: "/counseling",
    name: "counseling",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Counseling/listView"),
    meta: {
      layout: DashboardLayout,
    },
  },

  {
    path: "/counseling/answer/:id",
    name: "counselingAnswer",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Counseling/chatRoom"),
  },

  // broadcast section
  {
    path: "/broadcast",
    name: "broadcast",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Broadcast/listView"),
    meta: {
      layout: DashboardLayout,
    },
  },

  {
    path: "/broadcast/create",
    name: "createBroadcast",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Broadcast/createBroadcast"),
    meta: {
      layout: DashboardLayout,
    },
  },


  // package list
  {
    path: "/package",
    name: "package-list",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Package/listview"),
    meta: {
      layout: DashboardLayout,
    },
  },

  // banner page
  {
    path: "/banner",
    name: "banner",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Banner/bannerView"),
    meta: {
      layout: DashboardLayout,
    },
  },

  /* ====== Auth Section ====== */
  // login
  {
    path: "/login",
    name: "login",
    component: () => import("../views/LogIn.vue"),
  },
];

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (!localStorage.getItem("token") && to.name !== "login") {
    next("login");
  } else {
    next();
  }
});

export default router;
